/**
 * <pre>
 * Milestone utility methods.
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:Goal.Util
 * @namespace
 */
const Segment = {

	/**
	 * Build a segment definition object.
	 *
	 */
	buildSegmentDef: function(key, id, goal, value, percent, proportion=null, label=null, milestone=null) {

		let _segment = {
			key: 		key,
			id: 		id,
			goal: 		goal,
			value: 		value,
			percent: 	percent
		}

		// Optional label.
		if(label) {
			_segment.label = label;
		}

		// Optional milestone.
		if(milestone) {
			_segment.milestone = milestone;

			// If this Milestone has dates, set them.
			if(milestone.startDate && milestone.endDate) {
				_segment.dateStart 	= milestone.startDate;
				_segment.dateEnd 	= milestone.endDate;
			}
		}

		return _segment;
	}
}

export default Segment;